<section class="usage-hero" aria-labelledby="usage-hero-title">
  <h2 id="usage-hero-title" class="usage-hero__title">{{ 'usage.hero.title' | translate }}</h2>

  <div class="usage-hero__grid">
    <article
      *ngFor="let metric of metrics; trackBy: trackMetric"
      class="usage-hero__card"
      [class.usage-hero__card--warning]="metric.state === 'warning'"
      [class.usage-hero__card--over]="metric.state === 'blocking' || metric.state === 'overage_allowed'"
      [class.usage-hero__card--nodata]="!metric.hasData">

      <h3 class="usage-hero__label">{{ metric.label }}</h3>

      <ng-container *ngIf="metric.hasData; else noData">
        <p class="usage-hero__values">
          <strong class="usage-hero__consumed">{{ metric.consumedDisplay }}</strong>
          <span class="usage-hero__sep" aria-hidden="true">/</span>
          <span class="usage-hero__total">{{ metric.limitValueDisplay }}</span>
          <span class="usage-hero__unit" *ngIf="metric.unitLabel">{{ metric.unitLabel }}</span>
        </p>

        <p class="usage-hero__period" *ngIf="metric.periodLabel">{{ metric.periodLabel }}</p>

        <p class="usage-hero__percent" *ngIf="metric.displayPercent !== null">
          <span class="usage-hero__percent-value">{{ metric.displayPercent | number:'1.0-0' }}%</span>
          <span class="usage-hero__percent-label">{{ 'usage.hero.used' | translate }}</span>
        </p>

        <progress
          *ngIf="metric.displayPercent !== null"
          class="usage-hero__progress"
          [value]="metric.progressWidth"
          max="100"
          [attr.aria-label]="metric.label + ' ' + (metric.displayPercent | number:'1.0-0') + '%'">
          {{ metric.displayPercent | number:'1.0-0' }}%
        </progress>
      </ng-container>

      <ng-template #noData>
        <p class="usage-hero__nodata" role="status">{{ 'usage.hero.no_data' | translate }}</p>
      </ng-template>
    </article>
  </div>
</section>
